<template>
    <label class="flex cursor-pointer" :class="description === null ? 'items-center' : 'items-start'">
        <span class="flex items-center h-5">
            <input :id="id"
                   type="checkbox"
                   class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                   :checked="checked"
                   @change="handleChange"
                   :disabled="disabled">
        </span>
        <slot>
            <div class="ml-3 select-none" v-if="label !== null">
                <div :class="[{'text-opacity-50' : disabled}, labelStyling]">{{ label }}</div>
                <p v-if="description !== null" :id="id + '_description'" class="text-gray-500" :class="[descriptionStyling]">{{ description }}</p>
            </div>
        </slot>
        <slot name="errorMessage"></slot>
    </label>
</template>

<script>
export default {
    name: "tailwind-checkbox",
    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        value: {
            required: true,
            type: Boolean,
            default: false
        },
        label: {
            required: false,
            type: String,
            default: null
        },
        labelStyling:{
            required: false,
            type: String,
            default: 'text-sm font-medium text-gray-700'
        },
        description: {
            required: false,
            type: String,
            default: null
        },
        descriptionStyling:{
            required: false,
            type: String,
            default: 'text-sm'
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            checkboxValue: this.value
        };
    },
    mounted () {
        this.checkboxValue = this.value;
    },
    computed: {
        checked () {
            return this.checkboxValue === true;
        },
    },
    watch: {
        value (newValue) {
            this.checkboxValue = newValue;
        }
    },
    methods: {
        handleChange (e) {
            this.$emit("input", e.target.checked);
        }
    }
};
</script>

<style scoped>
</style>